export * from './fadeInUp.animation';
export * from './slideInRight.animation';
export * from './bounceIn.animation';
export * from './fadeInOut.animation';
export * from './slide.animation';



// WEBPACK FOOTER //
// ./src/app/shared/animations/index.ts